/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable arrow-body-style */
import { Box, maxWidth } from '@mui/system';
import React, { useEffect, useState, useCallback } from 'react';
import CTable from 'components/CTable';
import { GLOBAL_DATE_FORMAT, LIST_LIMIT } from 'constant';
import { useLazyGetInProgressListQuery, useLockUnlockAnctivityEntryMutation } from 'store/services/activityTimeEntry';
import useAuth from 'hooks/useAuth';
import moment from 'moment';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Tooltip } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import ConfirmationModal from 'components/reusable/ConfirmationModal';
import useSnackbar from 'hooks/useSnackbar';
import { Close, Lock, VisibilityTwoTone } from '@mui/icons-material';
import usePermission from 'hooks/usePermission';
import { useLazyGetActivityTimeDetailsQuery } from 'store/services/activitySetup';
import TimeEntryView from './TimeEntryView';
import HistoryIcon from '@mui/icons-material/History';
import HistoryView from './HistoryPopup';

const allyProps = {
    minwidth: 160,
    flex: 1,
    sortable: false
};

const Signed = ({ filterValues, therapist }) => {
    const { user } = useAuth();
    const [trigger, { data: inProgressData, isFetching: inProgressLoading }] = useLazyGetInProgressListQuery();
    const [triggerActivityTimeDetails, { data: details, isLoading: isDetailLoading, isFetching: isDetailFetching }] =
        useLazyGetActivityTimeDetailsQuery();
    const [list, setList] = useState({ fields: [] });
    const [page, setPage] = useState(1);
    const { notify } = useSnackbar();
    const { hasPermission } = usePermission();

    useEffect(() => {
        setPage(1);
    }, [filterValues]);
    const [fetchKey, setFetchKey] = useState(0);
    const [unlockId, setUnlockId] = useState(null);
    const [view, setView] = useState(null);
    const [viewData, setViewData] = useState(null);
    const handleUnlockOpen = (id) => {
        setUnlockId(id);
    };

    const handleView = async (id) => {
        const details = await triggerActivityTimeDetails({
            client_id: user?.client_id,
            id
        });
        setViewData(details?.data?.fields);
        setView(true);
    };

    const handleUnlockClose = () => {
        setUnlockId(null);
    };

    const [lockUnlock, { isLoading: lockUnlockLoading }] = useLockUnlockAnctivityEntryMutation();
    const SIGNED = 7;
    const INVOICED = 37;

    const cols = (handleHistory) => [
        {
            field: 'date',
            headerName: 'Date',
            ...allyProps,
            maxWidth: 120,
            align: 'center',
            headerAlign: 'center',
            valueGetter: (params) => moment.utc(params?.value).local().format(GLOBAL_DATE_FORMAT)
        },
        {
            field: 'location',
            headerName: 'Location',
            align: 'center',
            headerAlign: 'center',
            valueGetter: (params) => {
                return params.row.location?.name || '';
            },
            ...allyProps
        },
        {
            field: 'Service',
            headerName: 'Service',
            align: 'center',
            headerAlign: 'center',
            valueGetter: (params) => {
                return params.row?.service?.service_name || '';
            },
            ...allyProps
        },
        {
            field: 'therapist',
            headerName: 'Therapist',
            align: 'center',
            headerAlign: 'center',
            valueGetter: (params) => params.row.therapist?.name || '',
            ...allyProps
        },
        {
            field: 'total_minutes',
            headerName: 'Total Minutes',
            align: 'center',
            headerAlign: 'center',
            valueGetter: (params) =>
                (params.row?.time_entry_details_time_entry || []).reduce((sum, item) => sum + (Number(item?.minutes) || 0), 0) || '',
            ...allyProps
        },

        {
            field: 'actions',
            headerName: 'Actions',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                // console.log('COMPLETED::', params?.row?.time_entry_details_time_entry?.[0]?.current_status?.name);
                const isInvoiced = params?.row?.time_entry_details_time_entry?.some((entry) => entry?.current_status?.id === INVOICED);
                return (
                    <Stack direction="row" alignItems="center" justifyContent="center" sx={{ width: '100%' }}>
                        {hasPermission(['time_entry_view']) && (
                            <Tooltip title="View">
                                <IconButton title="Unlock" color="primary" onClick={() => handleView(params?.row?.id)}>
                                    <VisibilityTwoTone color="secondary" />
                                </IconButton>
                            </Tooltip>
                        )}
                        {hasPermission(['time_entry_unlock']) && params?.row?.is_full_signed && !isInvoiced && (
                            <Tooltip title="Unlock">
                                <IconButton title="Unlock" color="primary" onClick={() => handleUnlockOpen(params?.row?.id)}>
                                    <LockOpenIcon />
                                </IconButton>
                            </Tooltip>
                        )}

                        {params?.row?.is_full_signed && (
                            <Tooltip title={isInvoiced ? 'Invoiced' : 'Signed'}>
                                <IconButton title="Signed" color="primary">
                                    <Lock />
                                </IconButton>
                            </Tooltip>
                        )}
                        {hasPermission(['time_entry_view']) && (
                            <Tooltip title="View History">
                                <IconButton color="secondary" size="large" onClick={() => handleHistory(params?.row?.id)}>
                                    <HistoryIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Stack>
                );
            },
            ...allyProps,
            minwidth: 300
        }
    ];

    const payload = {
        filters: {
            ...(user?.client_id && { client_id: user.client_id }),

            ...(filterValues.startDate && {
                start_date: moment(new Date(filterValues.startDate)).startOf('day').utc().format('YYYY-MM-DD HH:mm')
            }),
            ...(filterValues.endDate && {
                end_date: moment(new Date(filterValues.endDate)).endOf('day').utc().format('YYYY-MM-DD HH:mm')
            }),
            ...(filterValues.locations.length > 0 && { location_ids: filterValues.locations }),
            ...(filterValues.service_id.length > 0 && { service_ids: filterValues.service_id }),
            ...(therapist && { therapist_ids: [therapist?.emp_id] }),
            status_ids: [SIGNED]
        },
        pagination: {
            current_page: page
        }
    };

    const handleLockUnlock = async () => {
        if (lockUnlockLoading) {
            return;
        }
        try {
            const unlockPayload = {
                id: unlockId
            };

            const res = await lockUnlock(unlockPayload).unwrap();
            handleUnlockClose();
            notify({ message: res.message, severity: 'success' });
            await trigger(payload);
        } catch (error) {
            notify({ message: error.data?.message || 'Something went wrong', severity: 'error' });
        }
    };

    useEffect(() => {
        setPage(1); // reset page
        setFetchKey((prev) => prev + 1); // force trigger
    }, [therapist]);

    useEffect(() => {
        trigger(payload);
    }, [filterValues, page, user?.client_id, fetchKey]);

    useEffect(() => {
        if (inProgressData && !inProgressLoading) {
            setList(inProgressData);
        }
    }, [inProgressData, inProgressLoading]);

    const handlePageChange = useCallback((_e, val) => {
        setPage(val);
    }, []);

    const handleDialogClose = () => {
        setView(false);
    };

    const [timeSheetId, setTimeSheetId] = useState(null);
    const handleHistory = (id) => {
        setTimeSheetId(id);
    };

    const handleHistoryClose = () => {
        setTimeSheetId(null);
    };

    return (
        <Box>
            <Box sx={{ height: 'calc(100vh - 280px)', my: 2 }}>
                <CTable
                    loading={inProgressLoading || lockUnlockLoading}
                    rows={list?.fields || []}
                    cols={cols(handleHistory)}
                    getRowId={(row) => row?.id}
                    currentPage={page}
                    totalCount={list?.pagination?.total_records || 0}
                    countPerPage={list?.pagination?.records_per_page || LIST_LIMIT}
                    onPageChange={handlePageChange}
                />
            </Box>
            <ConfirmationModal
                open={Boolean(unlockId)}
                handleClose={handleUnlockClose}
                handleConfirm={handleLockUnlock}
                title="Unlock Time Sheet"
                description="Are you sure you want to unlock this time sheet?"
            />
            <Dialog open={view} fullWidth maxWidth="sm">
                <IconButton
                    onClick={() => {
                        handleDialogClose();
                    }}
                    sx={{ position: 'absolute', top: 0, right: 0, m: 1 }}
                >
                    <Close />
                </IconButton>
                <DialogTitle
                    id="alert-dialog-title"
                    sx={{
                        fontSize: '16px'
                    }}
                >
                    Time Sheet Details
                </DialogTitle>
                <DialogContent>
                    <TimeEntryView data={viewData} />
                </DialogContent>
            </Dialog>
            <HistoryView pcId={timeSheetId} handleClose={handleHistoryClose} />
        </Box>
    );
};

export default Signed;